import { Deserializable } from '../_common/deserializable';

export class Subscriber implements Deserializable{
    id: number;
    source: string;
    sourceId: string;
    shortCode: string;
    keyword: string;
    phone: string;
    operator: string;
    country: string;
    interval: string;
    subscribeMoId: number;
    unsubscribeMoId: number;
    clickId: string;
    active: boolean;
    subscribeDate: string;
    unsubscribeDate: string;
    createdAt: string;
    reference: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
